import React, { useEffect, useState, useContext, useRef } from "react";
import { Typography, Stack, Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
//Import from project
import "./incomereport.scss";
import CashReceivingVoucher from "./CashReceivingVoucher";
import CashReceivingVoucherDetails from "./CashReceivingVoucherDetails";

export default function IncomeReport() {
  let tabReportFromLocal = JSON.parse(
    window.localStorage.getItem("tabReportFromLocal")
  );
  const [tabName, setTabName] = useState(
    tabReportFromLocal ? tabReportFromLocal : "first"
  );

  const handleFirstTab = (e) => {
    setTabName(e);
    window.localStorage.setItem("tabReportFromLocal", JSON.stringify(e));
  };
  const handleSecondTab = (e) => {
    setTabName(e);
    window.localStorage.setItem("tabReportFromLocal", JSON.stringify(e));
  };

  return (
    <Stack direction="column" spacing={2} className="import-details">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="row" spacing={2}>
          <Box className="slash" />
          <Stack direction="column" justifyContent="center">
            <Link to="/report" className="page-link-title">
              <Typography className="page-title">Report</Typography>
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="page-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="page-title">Income Report</Typography>
          </Stack>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              Dashboard
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">Income Report</Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box className="tabs-containner">
        <Box className="box-container">
          <Stack direction="row">
            <Button
              onClick={() => handleFirstTab("first")}
              className={tabName === "first" ? "active-btn-tabs" : "btn-tabs"}
            >
              Cash receiving voucher
            </Button>

            <Button
              onClick={() => handleSecondTab("second")}
              className={tabName === "second" ? "active-btn-tabs" : "btn-tabs"}
            >
              Cash receiving details
            </Button>
          </Stack>
        </Box>
      </Box>

      <Box>
        {tabName === "first" ? (
          <CashReceivingVoucher />
        ) : tabName === "second" ? (
          <CashReceivingVoucherDetails />
        ) : null}
      </Box>
    </Stack>
  );
}
